<template>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <h5>Performing action...</h5>
      </div>
    </div>
  </div>
</template>

<script>
import { layoutMethods, peddlrWalletMethods } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  props: ["token", "action"],
  methods: {
    ...peddlrWalletMethods,
    ...layoutMethods,
    goToList(){
      this.$router.push({ name:"Adjustment Transaction Dashboard" });
    }
  },
  mounted() {
    this.changeTitle({title: 'Adjustment Transaction Action'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "kankolek", to: { name: "" } },
        { text: "Adjustment Transaction", to: { name: "" } },
        { text: "Action", to: { name: "" } },
      ],
    });

    this.adjustmentAction({
      token: this.token,
      action: this.action
    })
      .then((res) => {
        if (res.status == "ok") {
          Swal.fire({
            title: "Action Successful!",
            text: `Adjustment Transaction has been ${this.action == 'approve' ? 'approved' : 'denied' } successfully.`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#c4297c",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.goToList();
            }
          });
        } else {
          Swal.fire({
            title: "Action Failed!",
            text: `Adjustment Transaction has failed due to ${res.message}`,
            icon: "info",
            showCancelButton: false,
            confirmButtonColor: "#c4297c",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.value) {
              this.goToList();
            }
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Action Failed!",
          html: `Adjustment Transaction has not been ${this.action == 'approve' ? 'approved' : 'denied' }.<br />${error}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#c4297c",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.value) {
            this.goToList();
          }
        });
      });
  }
};
</script>

<style>
</style>